var path = '/javascript/common/directives/callout.html';
var html = "<div class=\"flex-row\">\n    <div class=\"column column-xs-12\">\n        <div class=\"callout\" ng-class=\"[type]\" ng-transclude>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;